"use client";

import { useState } from "react";
import { Tabs, Form, Input, Switch, Select, Button, message } from "antd";

const { TabPane } = Tabs;
const { Option } = Select;

const SystemSettings = () => {
  const [form] = Form.useForm();
  const [activeTab, setActiveTab] = useState("1");

  const handleTabChange = (key) => {
    setActiveTab(key);
  };

  const onFinish = (values) => {
    console.log("Einstellungen gespeichert:", values);
    message.success("Einstellungen wurden erfolgreich gespeichert");
  };

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-6">Systemeinstellungen</h1>
      <Tabs activeKey={activeTab} onChange={handleTabChange}>
        <TabPane tab="Allgemein" key="1">
          <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
            initialValues={{
              siteName: "Meine Webseite",
              siteDescription: "Eine tolle Webseite",
              maintenanceMode: false,
            }}
          >
            <Form.Item
              name="siteName"
              label="Webseitenname"
              rules={[
                {
                  required: true,
                  message: "Bitte geben Sie einen Webseitennamen ein",
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item name="siteDescription" label="Webseitenbeschreibung">
              <Input.TextArea rows={4} />
            </Form.Item>
            <Form.Item
              name="maintenanceMode"
              label="Wartungsmodus"
              valuePropName="checked"
            >
              <Switch />
            </Form.Item>
          </Form>
        </TabPane>
        <TabPane tab="Sicherheit" key="2">
          <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
            initialValues={{
              passwordPolicy: "strong",
              twoFactorAuth: false,
              sessionTimeout: "30",
            }}
          >
            <Form.Item
              name="passwordPolicy"
              label="Passwort-Richtlinie"
              rules={[
                {
                  required: true,
                  message: "Bitte wählen Sie eine Passwort-Richtlinie",
                },
              ]}
            >
              <Select>
                <Option value="weak">Schwach</Option>
                <Option value="medium">Mittel</Option>
                <Option value="strong">Stark</Option>
              </Select>
            </Form.Item>
            <Form.Item
              name="twoFactorAuth"
              label="Zwei-Faktor-Authentifizierung"
              valuePropName="checked"
            >
              <Switch />
            </Form.Item>
            <Form.Item
              name="sessionTimeout"
              label="Sitzungs-Timeout (Minuten)"
              rules={[
                {
                  required: true,
                  message: "Bitte geben Sie einen Sitzungs-Timeout ein",
                },
              ]}
            >
              <Input type="number" />
            </Form.Item>
          </Form>
        </TabPane>
        <TabPane tab="Benachrichtigungen" key="3">
          <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
            initialValues={{
              emailNotifications: true,
              pushNotifications: false,
              notificationFrequency: "daily",
            }}
          >
            <Form.Item
              name="emailNotifications"
              label="E-Mail-Benachrichtigungen"
              valuePropName="checked"
            >
              <Switch />
            </Form.Item>
            <Form.Item
              name="pushNotifications"
              label="Push-Benachrichtigungen"
              valuePropName="checked"
            >
              <Switch />
            </Form.Item>
            <Form.Item
              name="notificationFrequency"
              label="Benachrichtigungshäufigkeit"
              rules={[
                {
                  required: true,
                  message: "Bitte wählen Sie eine Benachrichtigungshäufigkeit",
                },
              ]}
            >
              <Select>
                <Option value="realtime">Echtzeit</Option>
                <Option value="hourly">Stündlich</Option>
                <Option value="daily">Täglich</Option>
                <Option value="weekly">Wöchentlich</Option>
              </Select>
            </Form.Item>
          </Form>
        </TabPane>
      </Tabs>
      <div className="mt-6">
        <Button type="primary" onClick={() => form.submit()}>
          Einstellungen speichern
        </Button>
      </div>
    </div>
  );
};

export default SystemSettings;
